export class LinesHelper {
    static getOrientationLabel(orientation) {
        let output = "";

        switch (orientation) {
            case 'C':
                output = "Circular";
                break;

            case 'R':
                output = "Volta";
                break;

            case 'G':
                output = "Ida";
                break;

            case undefined:
                output = "Não Definido";
                break;

            default:
                output = "Ambos";
                break;
        }

        return output;
    }

    static getName(line) {
        if(undefined === line || null === line) {
            return "";
        }

        return `${line.code} | ${line.goName} | ${this.getOrientationLabel(line.orientation)}`;
    }

    static getShortName(line) {
        if(undefined === line || null === line) {
            return "Sem Linha";
        } 

        return `${line.code} [${this.getOrientationLabel(line.orientation)}]`;
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/schedules/tml/helpers/LinesHelper.js